export default {
      id: "facebook-usage",
      viewBox: "0 0 12.784 23.869",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#facebook",
      toString: function () {
        return this.url;
      }
    }